import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { Routes, RouterModule, mapToCanActivate } from '@angular/router';
import {
  AgrPageDetailModule,
  AgrNotificationEmptyModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { CustomerGuard } from '@next/core-lib/relationships';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { BatchConfigurationComponent } from './components/batch-configuration/batch-configuration.component';
import { BatchOverviewComponent } from './components/batch-overview/batch-overview.component';
import { CompleteComponent } from './components/complete/complete.component';
import { InformationComponent } from './components/information/information.component';
import { BatchConfigurationAddGuard } from './guards/batch-configuration-add.guard';
import { BatchConfigurationEditGuard } from './guards/batch-configuration-edit.guard';
import { RegistrationGuard } from './guards/registration-guard';
import { RegistrationComponent } from './registration.component';
import { RegistrationEffects } from './store/effects/registration.effects';
import { reducer } from './store/reducers/registration.reducer';

const routes: Routes = [
  { path: '', component: InformationComponent, canActivate: mapToCanActivate([CustomerGuard]) },
  {
    path: 'batches',
    children: [
      {
        path: '',
        component: BatchOverviewComponent,
        canActivate: mapToCanActivate([CustomerGuard]),
      },
      {
        path: 'add',
        component: BatchConfigurationComponent,
        canActivate: mapToCanActivate([BatchConfigurationAddGuard, CustomerGuard]),
      },
      {
        path: ':id',
        component: BatchConfigurationComponent,
        canActivate: mapToCanActivate([BatchConfigurationEditGuard, CustomerGuard]),
      },
    ],
  },
  {
    path: 'complete',
    component: CompleteComponent,
    canActivate: mapToCanActivate([CustomerGuard]),
  },
];

@NgModule({
  declarations: [
    BatchConfigurationComponent,
    BatchOverviewComponent,
    CompleteComponent,
    InformationComponent,
    RegistrationComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: 'registration',
        component: RegistrationComponent,
        children: routes,
        canActivate: mapToCanActivate([RegistrationGuard]),
      },
    ]),
    AgrPageDetailModule,
    AgrFormModule,
    AgrNotificationEmptyModule,
    AgrValueRowModule,
    MatTabsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatAutocompleteModule,
  ],
  providers: [provideState('registrationModule', reducer), provideEffects([RegistrationEffects])],
  exports: [],
})
export class RegistrationModule {}
